import React, { useEffect, useRef, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { FairnessFormGroup, useSelectedResultInfoStore } from '@pascal/pascal-core';
import {
  CARDS,
  CARDS_TYPE,
  CUTTING_CARD_VIEW_TYPES,
  UNKNOWN_CARD_TYPE,
} from '../../enums/cardTypes';
import { cardsStore } from '../../store/cardsStore';
import { AboutHash } from '../aboutHashComp/aboutHash';

export const CheckHashPopup = observer(() => {
  const {
    selectedResultInfo: { card },
  } = useSelectedResultInfoStore();
  const { selectedCardBackSideType, selectedCardType } = cardsStore;
  const scrollRef = useRef(null);
  const [toggle, setToggle] = useState(false);

  useEffect(() => {
    setToggle(false);
  }, []);

  useEffect(() => {
    if (toggle && scrollRef.current) {
      scrollRef.current.scrollIntoView();
    }
  }, [toggle]);

  return (
    <div className='hash-code-wrp'>
      <div className='fairness-cards'>
        <div
          className={`fairness-card ${
            card === UNKNOWN_CARD_TYPE && card !== CARDS.CUTTING_CARD
              ? selectedCardBackSideType
              : `${CARDS_TYPE[card]} ${selectedCardType}`
          } ${card === CARDS.CUTTING_CARD ? CUTTING_CARD_VIEW_TYPES : ''}
          `}
        />
        {/* add class  backside-(1 - 4), calode-1, card-(As) */}
      </div>
      <div className='bc-forms-holder'>
        <FairnessFormGroup isShowCopyIcon isCheckResult isShowAboutHash aboutHashComp={AboutHash} />
      </div>
    </div>
  );
});
